import PricingOptionCategoryList from "../../../components/pricingOptionCategoryList/pricingOptionCategoryList";
import { connect } from "react-redux";
import { actionCreators } from "../redux/sagas/pricingOptionsMapping/pricingOptionsMapping";

export default connect(
  state => ({
    data: state.pricingOptionsMapping.primaryRevenueCategories.result,
    tagNames: state.pricingOptionsMapping.primaryRevenueCategories.tag_names,
    tagChanges: state.pricingOptionsMapping.primaryRevenueCategories.tag_changes,
    pricingOptions: state.pricingOptionsMapping.pricingOptions,
    searchedPricingOptions: state.pricingOptionsMapping.searchedPricingOptions,
    optionLoading: state.pricingOptionsMapping.optionLoading,
    searchActive: state.pricingOptionsMapping.searchParams.active,
    searchQuery: state.pricingOptionsMapping.searchParams.query,
    showEmpty: state.pricingOptionsMapping.showEmpty,
    showInactive: state.pricingOptionsMapping.showInactive,
    haveError: state.pricingOptionsMapping.haveError,
    error: state.pricingOptionsMapping.error,
    modalLoading: state.pricingOptionsMapping.modalLoading,
    tagsLoading: state.pricingOptionsMapping.tagsLoading
  }),
  {
    getPricingOption: (id, rowId) => {
      return actionCreators.getPricingOption({ id: id, rowId: rowId });
    },
    updatePricingOption: (tag, id, cat, active, row) => {
      return actionCreators.updatePricingOption({ tag: tag, id: id, cat: cat, active: active, row: row });
    },
    massUpdateCategory: (changeId, values, row, catId) => {
      return actionCreators.massUpdateCategory({ changeId: changeId, values: values, row: row, catId: catId });
    },
    massUpdateTags: (tags, nonTags, values, row, catId) => {
      return actionCreators.massUpdateTags({ tags: tags, nonTags: nonTags, values: values, row: row, catId: catId });
    },
    createNewCategory: (name, type) => {
      return actionCreators.createNewCategory({ name: name, type: type });
    },
    createSecondaryCategory: (id, name, catType, paymentType, revenueType, calcValue) => {
      return actionCreators.createSecondaryCategory({
        id: id,
        name: name,
        catType: catType,
        paymentType: paymentType,
        revenueType: revenueType,
        calcValue: calcValue
      });
    },
    deleteSecondaryCategory: id => {
      return actionCreators.deleteSecondaryCategory(id);
    },
    deletePrimaryCategory: id => {
      return actionCreators.deletePrimaryCategory(id);
    },
    closeSearch: value => {
      return actionCreators.closeSearch(value);
    },
    toggleShowEmpty: value => {
      return actionCreators.toggleShowEmpty(value);
    },
    toggleShowInactive: value => {
      return actionCreators.toggleShowInactive(value);
    },
    searchCategories: value => {
      return actionCreators.searchCategories(value);
    },
    clearErrors: value => {
      return actionCreators.clearErrors(value);
    },
    getCategoriesByTag: value => {
      return actionCreators.getCategoriesByTag(value);
    }
  }
)(PricingOptionCategoryList);
